"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.participantFilterProvider = void 0;
const operators_1 = require("rxjs/operators");
const domain_id_1 = require("@streem/domain-id");
function participantFilterProvider(userId) {
    return (0, operators_1.filter)((participant) => {
        if (!userId) {
            return false;
        }
        return userId.compare(new domain_id_1.UserId(participant.userSid));
    });
}
exports.participantFilterProvider = participantFilterProvider;
//# sourceMappingURL=participant_filter_provider.js.map